import api from '../api/client';
// components/SalesChart.js
import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const SalesChart = ({ data }) => {
    // console.log(data, "sales data");
    const chartData = {
        labels: data?.map((item) => item.category),
        datasets: [
            {
                data: data?.map((item) => item.total_sales),
                backgroundColor: [
                    'rgba(54, 162, 235, 0.7)',
                    'rgba(75, 192, 192, 0.7)',
                    'rgba(255, 159, 64, 0.7)',
                    'rgba(153, 102, 255, 0.7)',
                    'rgba(255, 99, 132, 0.7)',
                    'rgba(255, 206, 86, 0.7)'
                ],
                borderWidth: 1
            }
        ]
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'right'
            },
            title: {
                display: true,
                text: 'Sales by Category'
            }
        }
    };

    return (
        <>
            <Doughnut data={chartData} options={options} />
        </>
    );
};

export default SalesChart;
